// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import TimestampUser from '@deere/cps-it.warranty-model-factory/lib/timestamp-user';
import actions from '../../actions-list';
import {postComponent} from '../../shared/repositories';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateComponents} from './components';

const resetComponentToAdd = pin =>

    dispatch => {

        dispatch({
            pin,
            type: actions.RESET_PRODUCT_DETAILS_COMPONENT_TO_ADD
        });

    };

export const createComponent = (pin, component) =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const createdBy = new TimestampUser({
                firstName: getState().user.details.firstName,
                id: getState().user.details.id,
                lastName: getState().user.details.lastName
            });

            component.createdBy = createdBy;
            await postComponent(pin, component);

            successAlertBar(translate('COMPONENT_CREATED_SUCCESSFULLY'));

            resetComponentToAdd(pin)(dispatch);

            dispatch({
                isVisible: false,
                type: actions.UPDATE_PRODUCT_DETAILS_SHOW_ADD_COMPONENT_ROW
            });

            updateComponents(pin)(dispatch);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const updateComponentToAdd = (property, value) =>

    dispatch => {

        dispatch({
            property,
            type: actions.UPDATE_PRODUCT_DETAILS_COMPONENT_TO_ADD,
            value
        });

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/component-to-add.js